export default __webpack_public_path__ + "static/media/airport.8afa85b5.jpg";